"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledList = exports.StyledItem = exports.LevelContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _globalTokens = require("../../../shared/global-tokens");
var NavigationMenuPrimitive = _interopRequireWildcard(require("@radix-ui/react-navigation-menu"));
// Level container to control indentation and show focus

var LevelContainer = exports.LevelContainer = _styledComponents.default.div.withConfig({
  displayName: "Sharedstyled__LevelContainer",
  componentId: "sc-1gmhqzq-0"
})(["padding-left:", "px;border-radius:0 ", " ", " 0;&:has(:focus-visible){outline:none;position:inherit;z-index:1;box-shadow:", " 0 0 ", ",0 -", " 0 ", ",0 ", " 0 ", ";}"], function (props) {
  return props.level * 24;
}, _globalTokens.globalBorder.radius['2'], _globalTokens.globalBorder.radius['2'], _globalTokens.globalBorder.width.thick, function (props) {
  return props.theme.sys.color.border.focusring;
}, _globalTokens.globalBorder.width.thick, function (props) {
  return props.theme.sys.color.border.focusring;
}, _globalTokens.globalBorder.width.thick, function (props) {
  return props.theme.sys.color.border.focusring;
});

// Item with styles
var StyledItem = exports.StyledItem = (0, _styledComponents.default)(NavigationMenuPrimitive.Item).withConfig({
  displayName: "Sharedstyled__StyledItem",
  componentId: "sc-1gmhqzq-1"
})(["display:flex;flex-direction:column;gap:4px;position:relative;width:100%;white-space:nowrap;", " color:", ";> a:hover{color:", ";}&[data-active='true']{a{", " color:", ";}}"], function (props) {
  return props.theme.sys.font.body['1'];
}, function (props) {
  return props.theme.sys.color.text.content.main;
}, function (props) {
  return props.theme.sys.color.text.content.main;
}, function (props) {
  return props.theme.sys.font.subheading['1'];
}, function (props) {
  return props.theme.sys.color.text.content.primary;
});
var StyledList = exports.StyledList = (0, _styledComponents.default)(NavigationMenuPrimitive.List).withConfig({
  displayName: "Sharedstyled__StyledList",
  componentId: "sc-1gmhqzq-2"
})(["all:unset;display:flex;box-sizing:border-box;flex-direction:column;align-items:flex-start;list-style:none;height:100%;padding:", " ", " ", " 0;flex:none;"], _globalTokens.globalSpacing['100'], _globalTokens.globalSpacing['100'], _globalTokens.globalSpacing['100']);